module.exports = __webpack_public_path__ + "5bc8141974769194cbf109e992e642f1.svg";